import { useEffect, useState } from "react";
import { generateAssetQRCodeDataURL } from "../../utils/helper";

export const ImageQr = ({ qr }) => {
  const [url, setUrl] = useState("");
  const getImageUrl = async () => {
    const img = await generateAssetQRCodeDataURL(qr);
    setUrl(img);
  };
  useEffect(() => {
    getImageUrl();
  }, []);
  return <img style={{ width: "100%" }} src={url} />;
};
